function o(t) {
  return {
    ...t,
    top: t.y,
    left: t.x,
    right: t.x + t.width,
    bottom: t.y + t.height
  };
}
export {
  o as rectToClientRect
};
//# sourceMappingURL=floating-ui.core.esm.js.map
